import { Injectable } from "@angular/core";
import { DirTypes, GridsterConfig } from "angular-gridster2";
import { AlertsService } from "src/modules/base/services/alerts.service";
import { LoaderService } from "src/modules/base/services/loader.service";
import { AppService } from "src/modules/base/shared/services/app.service";
import { BaseService } from "src/modules/base/shared/services/base.service";
import { SearchAndSelect } from "../../form/models/serachselect.model";

@Injectable()
export class DashboardService {
    constructor(private baseService: BaseService,public appService:AppService,public loader:LoaderService,public alerts:AlertsService) { }


    getWidgetData(widget_id,callback){
      let data = {
        "projectionKeys": "id,g_creation_time,g_modify_time,g_status,widget_name,widget_type,query,query_id,application,resource,time_period,interval,identifier,name,args,type,selector,filter,is_drilldown_available,drill_resource,custom_route,drill_query,labels_data,slider_type,slider_info,composite_data,isExternalLink,document_id,background_color,btn_text,link,heading,description,account_id,isMongoQueryEnable,operation,refresh_rate,documents,operation_field,date_field,cluster_name,extra_data,tag_data,time_filter",
        "args": "id:"+widget_id
      };
      this.baseService.getData(data, "", "widget_config", "account-management", "GET_WIDGET_BY_ID").subscribe((data: any) => {
        if (data.resource != null && data.resource[0] != undefined) {
          data.resource[0].timeFilterTargets = []
          if(data.resource[0].time_filter != undefined && Array.isArray(data.resource[0].time_filter) && data.resource[0].time_filter.length>0){
            for (let index = 0; index < data.resource[0].time_filter.length; index++) {
              const element = data.resource[0].time_filter[index];
              data.resource[0].timeFilterTargets.push({ table: element.time_field_table, column: element.time_field_key })
            }
            
          }
          callback(data.resource[0]);
        } else {
          callback(false);
        }
      },err=>{
        callback(false);
      });
    }

    prepreateWidgetData(widget){
            var widget = JSON.parse(JSON.stringify(widget));
            var arr = ["archival_required","g_created_by_id","g_created_by_name","g_created_by_role","g_created_by_role_type" , "g_creation_time","g_modify_time","g_modified_by_name","g_modified_by_role","g_modified_by_role_type","g_modified_by_id"];
            for (let index = 0; index < arr.length; index++) {
                delete widget[arr[index]];
            }
            return widget;
    }


    getGridsterOption():GridsterConfig{
      return {
			
        gridType: "scrollVertical",
        enableEmptyCellDrop: true,
        pushItems: true,
        swap: true,
        maxItemRows:100,
        maxItemCols:12,
        // itemChangeCallback: this.itemChange.bind(this),
        pushDirections: { north: true, east: true, south: true, west: true },
        resizable: { enabled: true },
        draggable: {
          enabled: true,
          ignoreContent: true,
          dropOverItems: true,
          dragHandleClass: "drag-handler",
          ignoreContentClass: "no-drag",
        },
        displayGrid: "always",
        minCols: 12,
        minRows: 10,
        dirType: this.appService.isRTLLayout()?DirTypes.RTL:DirTypes.LTR
      };
    }


    getDashboardUrl(id,type,configObject=null,callback){
      var datasource = {
          "resource": "report_summary",
          "application": "bireports",
          "query_id": "GET_DASHBOARD_URL",
          "args": "id:"+id+",type:"+type
      }
      if(configObject !=  undefined && configObject.url!= undefined){
        datasource.args += ",url:"+configObject.url;
      }
      if(configObject !=  undefined && configObject.report_id!= undefined){
        datasource.args += ",report_id:"+configObject.report_id;
      }
      if(configObject !=  undefined && configObject.facility_id!= undefined){
        datasource.args += ",facility_id:"+configObject.facility_id;
      }
      this.loader.showSpinner();
      this.baseService.getByDataSource(datasource).subscribe(res => {
        console.log("widgetdata===>",res)
        this.loader.hideSpinner();
        if (res.errCode == -1) {
          this.alerts.error(res.message);  
          callback(false)          
        }else if(res.resource != undefined && res.resource.length>0){
          var url = res.resource[0].id;
          callback(url)
        }       
      })
  }

  getEpochRange(fySettings,fyString: string, timezoneOffset: number) {
    let startYear = parseInt(fyString.split('-')[0], 10);
    if (fySettings.isYearAhead) { startYear = startYear - 1; }

    const startDate = new Date(Date.UTC(startYear, fySettings.startMonth, 1, 0, 0, 0));
    const nextYearDate = new Date(Date.UTC(startYear + 1, fySettings.startMonth, 1, 0, 0, 0));
    const endDate = new Date(nextYearDate.getTime() - 1);

    const offsetMs = timezoneOffset * 60 * 60 * 1000;
    const startMs = startDate.getTime() - offsetMs;
    const endMs = endDate.getTime() - offsetMs;

    return { startMs, endMs };
  }
}

export class FacilitySearchSelectModel {
  datasource = {
    "possible_value": []
  };
  defaultsetting = {
    "singleSelection": true,
    "checkBoxRequired": false,
    "closeDropDownOnSelection": true,
    "advancesearch": false
  };
  question = new SearchAndSelect({
    defaultsetting: this.defaultsetting,
    getterKey: 'id',
    getterValue: 'value',
    options: false,
    type: "String",
    format: '(function (item) {return item.value;})'
  });
}